import { CommunityApp } from '@atlassian/learning-components';
import { sendTrackEvent } from '../services/analytics';
import { getAnalyticsAnonymousId } from './utilities';

export const sendNewAccountEvent = async (isNewForumsProfile: boolean, userAccountId?: string) => {
  try {
    const articlePopupLoginClicked = window.sessionStorage.getItem('targeted_messaging2_login_clicked');
    if (articlePopupLoginClicked) {
      const variant = window.sessionStorage.getItem('targeted_messaging2_variant') || 'na';
      const allVisitedContentPages = JSON.parse(window.sessionStorage.getItem('targeted_messaging2_all_visited_content_pages') || "[]");
      const expSessionId = window.sessionStorage.getItem('targeted_messaging2_session_id') || 'na';

      await sendTrackEvent(
        CommunityApp.HOME,
        'targetedMessaging2',
        'signup',
        {
          isNewForumsProfile,
          anonymousId: getAnalyticsAnonymousId(),
          variant: JSON.parse(variant),
          expSessionId: JSON.parse(expSessionId),
          totalVisitCount: allVisitedContentPages.length,
          allVisitedContentPages,
          experimentName: 'community-forums-exp2-2nd-visit-popup'
        },
        userAccountId,
      );
      window.sessionStorage.removeItem('targeted_messaging2_login_clicked');
    }

    const anonymousKudosKey = 'community-forums-anonymous-kudos__login_clicked';
    const variantName = window.sessionStorage.getItem(anonymousKudosKey);
    if(variantName?.length) {
      window.sessionStorage.removeItem(anonymousKudosKey);
      await sendTrackEvent(
        CommunityApp.HOME,
        'authentication',
        'loggedIn',
        {
          isNewForumsProfile,
          anonymousId: getAnalyticsAnonymousId(),
          variantName,
          experiment: 'community-forums-anonymous-kudos'
        },
        userAccountId,
      );
    }
  } catch (error) {
    console.error('[sendNewAccountEvent] Error sending event:', error);
  }
};
